import { createSelector } from 'reselect';

import {
    getCatalogItems,
    getSelectedCatalogItems,
} from 'entities/CatalogItem/model/selectors/catalogItemSelectors';
import { calculateOrderSavings } from 'entities/Order/lib/calculateOrderSavings/calculateOrderSavings';
import { getSelectedOrderItems } from 'entities/Order/model/selectors/ordersSelectors';
import { isProposalInPriceCheck } from 'entities/Proposal/lib/isProposalInPriceCheck';

export const getCurrentOrderSummary = createSelector(
    [getCatalogItems, getSelectedCatalogItems],
    (catalogItems, selectedItems) => {
        let totalPrice = 0;
        let hasLoadingPrices = false;

        catalogItems?.forEach((item) => {
            if ('price' in item) {
                if (item.selectedProposals?.length > 0) {
                    let itemTotalPrice = 0;
                    item.selectedProposals?.forEach((selectedProposal) => {
                        itemTotalPrice +=
                            (selectedProposal.price || 0) *
                            (selectedProposal.selectedQuantity || 0);
                    });
                    totalPrice += itemTotalPrice;
                } else {
                    // If there are no selected proposals, use the price from the item and the total requested
                    const pricePerItem = item?.price;
                    const selectionKey = item.uuid ?? item.id;
                    totalPrice +=
                        pricePerItem * selectedItems?.[selectionKey]?.qty;
                }

                if (
                    !item.isCheckFinished &&
                    isProposalInPriceCheck(item?.proposals)
                )
                    hasLoadingPrices = true;
            }
        });

        return {
            totalPrice,
            hasLoadingPrices,
        };
    },
);

export const getOrderSavings = createSelector(
    [getSelectedOrderItems],
    (orderItems) => {
        if (!orderItems || orderItems.length === 0) {
            return {
                totalSavings: 0,
                averageSavingsPercentage: 0,
                itemsCount: 0,
            };
        }

        return calculateOrderSavings(orderItems);
    },
);
